import DoAction from "./DoAction";

/**
 * Manager for Undo/Redo history.
 */
export default class DoManager {
    constructor() {
        this.clear();
    }
    clear() {
		this.undos = [];
		this.redos = [];
    }
    registerDo(doaction, group) {
		doaction.group = group;
		if (0 < this.undos.length && this.undos[this.undos.length - 1].isGroupEnd && doaction.isGroupEnd) return;
        this.undos.push(doaction);
        this.redos = [];
    }
    undo() {
        if (0 < this.undos.length) { // Is undoable ?
			let cursor = 0;
			do {
				const doaction = this.undos.pop();
				// do
				doaction.undo();
                this.redos.push(doaction);
                
				// check lifecycle in group
				if (doaction.isGroupEnd) cursor++;
				if (doaction.isGroupBegin) cursor--;
			} while (cursor && 0 < this.undos.length);
		}
    }
    redo() {
		if (0 < this.redos.length) { // Is redoable ?
			let cursor = 0;
			do {
				const doaction = this.redos.pop();
				// do
				doaction.redo();
                this.undos.push(doaction);
                
				// check lifecycle in group
				if (doaction.isGroupBegin) cursor++;
				if (doaction.isGroupEnd) cursor--;
			} while(cursor && 0 < this.redos.length);
		}
	}
	beginDo() {
		this.registerDo(new DoAction(), true);
	};
	endDo() {
		this.registerDo(new DoAction(), false);
	};
}